import { fetchDetails as fetchCustomerDetails } from '../../../authentication/state/customer/AuthCustomer.commands';
import { fetchDetails as fetchUserDetails } from '/b2b/authentication/state/user/AuthUser.commands';
import fromState from '../../state/selectors';

export const refresh = params => (dispatch, getState) => {
    const isAdmin = fromState.Auth.user.isAdmin(getState());
    return isAdmin ? dispatch(fetchCustomerDetails(params)) : dispatch(fetchUserDetails(params));
};
